/*!
 * PageFlow — drag and drop page builder writing clean Bootstrap 5 HTML.
 * (c) Pandao — https://pageflow.pandao.eu
 * Licensed under the Envato Market licences (Regular or Extended): https://codecanyon.net/licenses/standard
 * Icons: Phosphor Icons (MIT).
 */
import './blocks/structure.js';
import './blocks/basic.js';
import './blocks/media.js';
import './blocks/components.js';
import { PageFlow, VERSION } from './core/editor.js';
import { registerBlock, unregisterBlock, getBlock, allBlocks } from './core/registry.js';
import { addLocale, locales } from './i18n/index.js';
import { sanitizeHtml, safeUrl } from './core/sanitize.js';
import { sectionTemplates, placeholder } from './sections/index.js';
import { installJQuery } from './jquery.js';
import { uiIcons } from './ui/icons.js';

/** PageFlow.create('#editor', options): the usual way to start an editor. */
function create(target, options) {
    return new PageFlow(target, options);
}

Object.assign(PageFlow, {
    version: VERSION,
    create,
    registerBlock,
    unregisterBlock,
    getBlock,
    blocks: allBlocks,
    addLocale,
    locales,
    sanitize: sanitizeHtml,
    safeUrl,
    sections: sectionTemplates,
    placeholder,
    icons: uiIcons, // names usable as the icon of a custom block or of a top bar action
    installJQuery,
});

installJQuery(typeof window !== 'undefined' ? window.jQuery : null, PageFlow);

export default PageFlow;
export { PageFlow, create, registerBlock, unregisterBlock, getBlock, addLocale, sanitizeHtml, safeUrl, sectionTemplates };
